<template>
  <v-stepper v-model="stepper1" dense flat :alt-labels="altLabels">
    <v-stepper-header>
      <v-stepper-step step="1" editable>
        Caricamento letture
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="2" editable :complete="lettureComplete">
        Scelta letture
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="3" editable>
        Categorie prodotti
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4" :editable="!isTerminaleOnline">
        Comparazione magazzino
        <small v-if="isTerminaleOnline">Movimenti già effettuati</small>
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="5" editable>
        Prodotti non contati
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <caricamento-letture />
      </v-stepper-content>
      <v-stepper-content step="2">
        <scelta-letture @selezione="onLettureSelezionate"/>
      </v-stepper-content>
      <v-stepper-content step="3">
        <scelta-categorie-prodotti @selezione="onCategorieSelezionate"/>
      </v-stepper-content>
      <v-stepper-content step="4">
        <comparazione-magazzino :letture="lettureSelezionate" :incluse="categorieIncluse" :escluse="categorieEscluse" :reload="triggerRefresh"/>
      </v-stepper-content>
      <v-stepper-content step="5">
        <prodotti-non-contati :letture="lettureSelezionate" :incluse="categorieIncluse" :escluse="categorieEscluse" :reload="triggerRefresh"/>
      </v-stepper-content>
    </v-stepper-items>         
  </v-stepper>
</template>

<script>
  import _ from 'lodash'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import CaricamentoLetture from './components/caricamentoLetture'
  import SceltaLetture from './components/sceltaLetture'
  import SceltaCategorieProdotti from './components/sceltaCategorieProdotti'
  import ComparazioneMagazzino from './components/comparazioneMagazzino'
  import ProdottiNonContati from './components/prodottiNonContati'

  export default {
    components: {
      CaricamentoLetture,
      SceltaLetture,
      SceltaCategorieProdotti,
      ComparazioneMagazzino,
      ProdottiNonContati
    },
    mixins: [verificaLicenza],
    data () {
      return {
        stepper1: 1,
        lettureSelezionate: [],
        categorieIncluse: {},
        categorieEscluse: {},
        triggerRefresh: 1,
        isTerminaleOnline: false
      }
    },
    async mounted() {
      await this.verificaModuliLocali()
    },
    watch: {
      stepper1(value) {
        if (value === '4') {
          this.triggerRefresh++
        }
      }
    },
    computed: {
      altLabels() {
        return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name)
      },
      lettureComplete() {
        return this.lettureSelezionate.length > 0
      }
    },
    methods: {
      onLettureSelezionate(elenco) {
        this.isTerminaleOnline = elenco.some(x => x.tipoFile === 'Terminale Online')
        this.lettureSelezionate = elenco
      },
      onCategorieSelezionate(categorie) {
        this.categorieIncluse = categorie.incluse
        this.categorieEscluse = categorie.escluse
      }
    }
  }
</script>
